import { makeCurrentUserPermissionChecker, Permission, PermissionChecker, Permissions } from '@/permissions';
import { computed, ref } from 'vue';
import { useInjector } from '@/di/use-injector';
import { useUserProfileDetailsStore } from '@/common/store/user-details/store';

export function usePermissions() {
    const userProfileDetails = useUserProfileDetailsStore();
    const injector = useInjector();
    const makePermissionChecker = injector.injectFunction(makeCurrentUserPermissionChecker);

    const checker = ref<PermissionChecker | null>(null);

    makePermissionChecker().then(permissionChecker => {
        checker.value = permissionChecker;
    });

    function hasPermission(permission: Permission) {
        return Boolean(checker.value?.hasPermission(permission));
    }

    function hasAnyPermission(...permissions: Permission[]) {
        return Boolean(checker.value?.hasAnyPermission(...permissions));
    }

    function hasEveryPermission(...permissions: Permission[]) {
        return Boolean(checker.value?.hasEveryPermission(...permissions));
    }

    const canAccessGroupReport = computed(() => {
        return hasPermission(Permissions.Reporting) || userProfileDetails.state.isReportingManager;
    });

    return { hasPermission, hasAnyPermission, hasEveryPermission, canAccessGroupReport };
}
